export default __webpack_public_path__ + "static/media/youtube-white.f86fb0c6.svg";